import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";
import {
  addGarmentPack,
  updateGarmentPack,
} from "../../../services/GarmentPack/GarmentPack";
import { postBrandPriceCode, putBrandPriceCode } from "../../../services/StorePriceCode/getPriceCode";

const GeneralPriceCreateModal = ({
  generalPriceCreateModalVisible,
  setGeneralPriceCreateModalVisible,
  sendDataToGeneralPriceCreateModal,
  brandId,
  selectedItemValue,
}) => {
  const [modalText, setModalText] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [statusError, setStatusError] = useState("");
  const [minMaxCheckEnabledValue, setMinMaxCheckEnabledValue] = useState("");
  const [minMaxCheckEnabledError, setMinMaxCheckEnabledError] = useState("");
  const [focusedField, setFocusedField] = useState("");
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [priceCodeValue, setPriceCodeValue] = useState("");
  const [priceCodeError, setPriceCodeError] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  const minMaxCheckEnabledItems = [
    {
      name: "Enabled",
      value: true,
    },
    {
      name: "Disabled",
      value: false,
    },
  ];
  useEffect(() => {
    if (selectedItemValue !== null) {
      setPriceCodeValue(selectedItemValue?.priceCode || "");
      setStatusValue(selectedItemValue?.status || false);
      setMinMaxCheckEnabledValue(
        selectedItemValue?.minMaxCheckEnabled || false
      );
    }
  }, [selectedItemValue]);

  const handleConfirmPickup = () => {
    // Reset all previous errors
    setPriceCodeError("");
    setStatusError("");
    setMinMaxCheckEnabledError("");

    let isValid = true;
    if (!priceCodeValue) {
      setPriceCodeError("Tariff Code is required");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedItemValue === null) {
          const data = {
            brandId: brandId,
            priceCode: priceCodeValue,
            description: priceCodeValue,
            priceType: "PRICE",
            status: true,
            minMaxCheckEnabled: true,
          };
          postBrandPriceCode(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }
                  setPriceCodeValue("");
                  setStatusValue("");
                  setMinMaxCheckEnabledValue("");
                  setPriceCodeError("");
                  setStatusError("");
                  setMinMaxCheckEnabledError("");
                  setIsSubmitButtonPressed(false);
                  sendDataToGeneralPriceCreateModal({
                    success: true,
                  });
                  setGeneralPriceCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            ...selectedItemValue,
            brandId: brandId,
            priceCode: priceCodeValue,
            description: priceCodeValue,
            priceType: "PRICE",
            status: statusValue,
            minMaxCheckEnabled: minMaxCheckEnabledValue,
          };
          putBrandPriceCode(brandId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setPriceCodeValue("");

                  setStatusValue("");
                  setMinMaxCheckEnabledValue("");
                  setPriceCodeError("");

                  setStatusError("");
                  setMinMaxCheckEnabledError("");
                  setIsSubmitButtonPressed(false);
                  sendDataToGeneralPriceCreateModal({
                    success: true,
                  });
                  setGeneralPriceCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const handleModalClose = () => {
    setPriceCodeValue("");
    setStatusValue("");
    setMinMaxCheckEnabledValue("");

    setPriceCodeError("");
    setStatusError("");
    setMinMaxCheckEnabledError("");
    setIsSubmitButtonPressed(false);
    setGeneralPriceCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={generalPriceCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!generalPriceCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Tariff {selectedItemValue === null ? "Create" : "Edit"}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="mx-4 mt-4">
              <FloatLabel>
                <InputText
                  id="priceCodeValue"
                  value={priceCodeValue}
                  onChange={(e) => setPriceCodeValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Tariff Code"
                />
                <label
                  htmlFor="priceCodeValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Tariff Code <span style={{ color: "red" }}>*</span>
                </label>
                {priceCodeError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {priceCodeError}
                  </p>
                )}
              </FloatLabel>
            </div>

            {selectedItemValue !== null && (
              <div>
                <div className="mx-4 mt-4  ">
                  <FloatLabel>
                    <Dropdown
                      id="statusValue"
                      value={statusValue}
                      onChange={(e) => setStatusValue(e.value)}
                      options={statusItems}
                      optionLabel="name"
                      placeholder="Status"
                      className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    />
                    {statusError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {statusError}
                      </p>
                    )}
                    <label
                      htmlFor="statusValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      Status
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </FloatLabel>
                </div>
                <div className="mx-4 mt-4  ">
                  <FloatLabel>
                    <Dropdown
                      id="minMaxCheckEnabledValue"
                      value={minMaxCheckEnabledValue}
                      onChange={(e) => setMinMaxCheckEnabledValue(e.value)}
                      options={minMaxCheckEnabledItems}
                      optionLabel="name"
                      placeholder="Status"
                      className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    />
                    {statusError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {statusError}
                      </p>
                    )}
                    <label
                      htmlFor="minMaxCheckEnabledValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      Min Max Value Check
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </FloatLabel>
                </div>
              </div>
            )}

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default GeneralPriceCreateModal;
